<template>

<app-view-list-field align="center" :demoted-icon="field.type" :is-sticky="isSticky" :is-demoted="isDemoted" :field="field" :filter="filter">

	<core-progress :percent="value" v-if="value !== false" />

</app-view-list-field>

</template>

<script>

export default {

	props: ['field', 'filter', 'item', 'isSticky', 'isDemoted'],

    computed: {

		value: function() {

			if (this.item.record.results) {

				return (100 / this.item.record.results) * this.item.record.wins

			} else {

				return false

			}

		}

    }

}

</script>

<style scoped>

.worth-primary >>> span.currency {
	font-size: 11px;
	color: #666;
}

</style>